var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.component.video
    ? _c("div", { staticClass: "vimeo-embed", style: _vm.containerStyle }, [
        !_vm.ready
          ? _c(
              "div",
              {
                staticClass:
                  "vimeo-embed__spinner d-flex justify-content-center align-items-center",
              },
              [_vm._m(0)]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("iframe", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ready,
              expression: "ready",
            },
          ],
          ref: "iframe",
          staticClass: "vimeo-embed__frame",
          attrs: {
            src: _vm.embedUrl,
            frameborder: "0",
            allow: "autoplay; fullscreen; picture-in-picture",
            allowfullscreen: "",
          },
          on: { load: _vm.onLoad },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "spinner-border", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }